/** Testable dev-only logging gate (defaults from Vite env at build time). */
export const devLogConfig = {
	enabled: import.meta.env.DEV,
};

export function logDevError(context: string, message: string) {
	if (devLogConfig.enabled) {
		console.error(context, message);
	}
}
